import styled from 'styled-components';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { useAnimatedPositionTransition } from 'utils/hooks/useAnimatedPositionTransition';
import { useAdAccountContext } from '../../contexts/AdAccountContext';
import { useFbcaTranslations } from '../../hooks/useTranslations';

type CheckBoxFieldProps = {
  adAccountId: string;
};

const CheckFieldWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  padding: ${({ theme }) => theme.spacing.values.base};
  border-radius: 4px;
  ${({ theme }) => theme.elevations.buttonShadow};
  background-color: #fff;
`;

const StyledIDLabel = styled.div`
  font-size: ${({ theme }) => theme.styles.fontSizes.s18};
  font-family: 'Sofia Pro', system-ui, -apple-system, BlinkMacSystemFont, 'Avenir Next', Avenir,
    'Segoe UI', 'Lucida Grande', 'Helvetica Neue', Helvetica, 'Fira Sans', Roboto, Noto,
    'Droid Sans', Cantarell, Oxygen, Ubuntu, 'Franklin Gothic Medium', 'Century Gothic',
    'Liberation Sans', sans-serif;
`;

export const CheckboxField = ({ adAccountId }: CheckBoxFieldProps) => {
  const { adAccountIds, addAdAccounts, removeAdAccounts } = useAdAccountContext();
  const { t } = useFbcaTranslations();

  const isChecked = adAccountIds.includes(adAccountId)
    ? CHECKBOX_STATUS.CHECKED
    : CHECKBOX_STATUS.UNCHECKED;
  const updateAdAccount = isChecked === CHECKBOX_STATUS.CHECKED ? removeAdAccounts : addAdAccounts;

  return (
    <CheckFieldWrapper ref={useAnimatedPositionTransition()} data-test="fb-checkfield-wrapper">
      <Checkbox status={isChecked} onClick={() => updateAdAccount(adAccountId)} />
      <StyledIDLabel data-test={`check-box-ad-account-${adAccountId}`}>
        {t('adAccountId.label', { adAccountId })}
      </StyledIDLabel>
    </CheckFieldWrapper>
  );
};
